<template>
  <div class="dash-container">
    <div class="dash">
      <dashboard-allocated-accomplished
        :totalStockDelivery="totalStockdelivery()"
        :channelInvoiceQtde="channelInvoiceQtde()"
        :channelRevenueQtde="channelRevenueQtde()"
        :channelBudgetQtde="channelBudgetQtde()"
        :day="day()"
        :loading="loading"
      />
    </div>
    <div class="dash">
      <dashboard-daily-production-goal
        :projected="projected()"
        :newChannelBudgetQtde="newChannelBudgetQtde()"
        :channelRevenueQtde="channelRevenueQtde()"
        :channelBudgetQtde="channelBudgetQtde()"
        :day="day()"
        :loading="loading"
      />
    </div>
    <div class="dash">
      <dashboard-accumulated-goal
        :projectedAccumulated="projectedAccumulated()"
        :channelRevenueQtdeAccumulated="channelRevenueQtdeAccumulated()"
        :channelBudgetQtdeAccumulated="channelBudgetQtdeAccumulated()"
        :day="day()"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import DashboardAllocatedAccomplished from './DashboardAllocatedAccomplished.vue';
import DashboardDailyProductionGoal from './DashboardDailyProductionGoal.vue';
import DashboardAccumulatedGoal from './DashboardAccumulatedGoal.vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  components: {
    DashboardAllocatedAccomplished,
    DashboardDailyProductionGoal,
    DashboardAccumulatedGoal,
  },

  methods: {
    ...mapActions('dashboardAllocatedAccomplished', [
      'fetchAllocatedAccomplished',
    ]),

    totalStockdelivery() {
      return this.allocatedAccomplished.map((day, index) => [
        index,
        day.TOTALSTOCKDELIVERY,
      ]);
    },

    channelInvoiceQtde() {
      return this.allocatedAccomplished.map((day, index) => [
        index,
        day.CHANNELINVOICEQTDE,
      ]);
    },

    channelRevenueQtde() {
      return this.allocatedAccomplished.map((day, index) => [
        index,
        day.CHANNELREVENUEQTDE,
      ]);
    },

    channelBudgetQtde() {
      return this.allocatedAccomplished.map((day, index) => [
        index,
        day.CHANNELBUDGETQTDE,
      ]);
    },

    projected() {
      return this.allocatedAccomplished.map((day, index) => [
        index,
        day.PROJECTED,
      ]);
    },

    newChannelBudgetQtde() {
      return this.allocatedAccomplished.map((day, index) => [
        index,
        day.NEWCHANNELBUDGETQTDE,
      ]);
    },

    channelRevenueQtdeAccumulated() {
      return this.allocatedAccomplished.map((day, index) => [
        index,
        day.CHANNELREVENUEQTDE_ACCUMULATED,
      ]);
    },

    projectedAccumulated() {
      return this.allocatedAccomplished.map((day, index) => [
        index,
        day.PROJECTED_ACCUMULATED,
      ]);
    },

    channelBudgetQtdeAccumulated() {
      return this.allocatedAccomplished.map((day, index) => [
        index,
        day.CHANNELBUDGETQTDE_ACCUMULATED,
      ]);
    },

    day() {
      return this.allocatedAccomplished.map((day) => {
        return new Date(day.DAY).toLocaleDateString('pt-BR', {
          month: '2-digit',
          day: '2-digit',
        });
      });
    },
  },

  mounted() {
    this.fetchAllocatedAccomplished();
  },

  computed: {
    ...mapGetters('dashboardAllocatedAccomplished', {
      loading: 'getLoading',
      allocatedAccomplished: 'getAllocatedAccomplished',
    }),
  },
});
</script>

<style lang="scss" scoped>
.dash-container {
  display: flex;
  flex-direction: column;
}
.dash {
  width: 100%;
  position: relative;
}
</style>
